/**
 * @fileoverview Theme initialization on app load.
 * @package PlayItNow
 * @module apps/front/lib/theme-init
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

/**
 * @summary Initialize theme on app load.
 */
export function initTheme() {
  if (typeof window === 'undefined') return

  const stored = localStorage.getItem('playitnow_theme')
  const theme = stored && ['light', 'dark', 'auto'].includes(stored) ? stored : 'light'
  
  const root = document.documentElement
  
  if (theme === 'auto') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    root.setAttribute('data-theme', prefersDark ? 'dark' : 'light')
  } else {
    root.setAttribute('data-theme', theme)
  }
}

